<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Profile</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{this.profileArr}} -->
              <form @submit.prevent="updateProfile" class="was-validated">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>
                        Name
                        <span class="text-danger">*</span>
                      </label>
                      <input class="form-control" type="text" v-model="profileArr.name" required />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input class="form-control" v-model="profileArr.email" type="email" required />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Phone Number</label>
                      <input class="form-control" v-model="profileArr.phone" type="number" />
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <button :disabled="isLoading" class="btn btn-primary submit-btn">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  data() {
    return {
      isLoading: false,
      profileArr: {
        email: "",
        name: "",
        phone: ""
      }
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    updateProfile() {
      this.isLoading = true;
      let dataParam = {
        member_name: this.profileArr.name,
        member_email: this.profileArr.email,
        member_mobilephone: this.profileArr.phone
      };
      this.$store
        .dispatch("member/updateProfile", dataParam)
        .then(response => {
          this.isLoading = false;

          let { data } = response;
          this.profileArr = data;

          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
          this.getProfile();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getProfile() {
      this.$store.dispatch("login/getProfile").then(response => {
        let { data } = response;
        this.profileArr = data;
      });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "settings"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/profile.vue